import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DarwinActions } from 'app/modules/darwin/darwin.actions';

@Component({
  selector: 'app-darwin-container',
  templateUrl: './darwin.component.html',
})
export class DarwinComponent implements OnInit {

  constructor(
    private readonly store: Store
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(DarwinActions.moduleInitialized());
  }

}
